import angular from 'angular';
import { uniq } from 'lodash';

import * as invoiceActions from '../../../../store/actions/invoice';

import template from './itemize.html';
import './itemize.less';

const mapStateToScope = (state) => {
  return {
    invoice: state.invoice,
    user: state.user.user,
    pets: state.pet.userPets,
    activeComponent: state.statsbar.activeComponent,
  };
};

angular.module('myConsultApp').directive('itemize', () => {
  return {
    controller: ($scope, $rootScope, $ngRedux, $http, ENV, $location, IdentityService) => {
      $scope.init = () => {
        $scope.model = {};
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, invoiceActions)($scope);
        $scope.isOrganizationUser = !$location.path().startsWith('/admin');
      };
      $scope.init();

      // close the add another product expanded view when the active component is closed
      // or if you are adding another pet
      $scope.activeComponentListener = $scope.$watch('activeComponent', (newValue) => {
        if (
          (!newValue || newValue === 'create-pet') &&
          $scope.invoice.items.length > 0 &&
          !$scope.hideAddLineItemView
        ) {
          $scope.showAddLineItemWhenUserReturns = true;
          $scope.hideAddLineItemView = true;
        }

        // when user returns to submit invoice and they we adding another product previously
        // open that view back up
        if (newValue === 'submit-invoice' && $scope.showAddLineItemWhenUserReturns) {
          $scope.showAddLineItemWhenUserReturns = false;
          $scope.hideAddLineItemView = false;
        }
      });

      // reset component when route changes
      $scope.$on('$routeChangeStart', async () => {
        $scope.hideAddLineItemView = false;
        $scope.model = {};
      });

      $scope.getSpeciesImage = (species) => {
        var img;
        if (species === 1) {
          img = '/images/default-canine-profile.png';
        } else if (species === 2) {
          img = '/images/default-feline-profile.png';
        }
        return img;
      };

      // when we select the pet we need to clear the model
      $scope.onSelectPet = (pet) => {
        $scope.model = {};
        $scope.model.pet = pet;
      };

      $scope.onAddPet = () => {
        if (!$scope.isOrganizationUser) {
          $scope.setActiveComponent('create-pet', {
            onBefore: () => {
              $scope.setActiveUser($scope.invoice.user);
            },
            onClose: () => {
              $scope.setActiveComponent('submit-invoice');
              $('.admin-overlay').css({ display: 'block' });
            },
          });
        } else {
          IdentityService.storeUser($scope.user);
          $location.url('/find-a-pet/create/?submitInvoice=true');
        }
      };

      $scope.sortSku = (product) => parseInt(product.sort);

      $scope.hideAddLineItemView = false;

      /**
       * Checks if we should be showing the dosage and/or package input fields
       * Only show dosage field if we have more than one dosage label for a product.
       * Only show package field if the dosage field has been set or if we only have one package type for a dosage.
       */
      $scope.checkToShowDosageAndPackageFields = () => {
        const skus = $scope.model.product.skus;

        const dosagesForBrand = uniq(skus.map((sku) => sku.dosage_label));
        if (dosagesForBrand?.length <= 1) {
          $scope.model.dosage = dosagesForBrand[0];
        }
        $scope.model.showDosageField = $scope.model.product && dosagesForBrand.length > 1;

        const packagesForDosage = uniq(
          skus
            .filter((sku) =>
              $scope.model.dosage ? $scope.model.dosage === sku.dosage_label : true,
            )
            .map((sku) => sku.package_label),
        );
        if (packagesForDosage <= 1) {
          $scope.model.package = packagesForDosage[0];
        }

        $scope.model.showPackageField =
          ($scope.model.dosage || dosagesForBrand.length === 1) && packagesForDosage.length > 1;
      };

      /**
       * When product, dosage. or package values change we check to see if we have a matching sku
       * If we have a mtaching sku and it is different than what we previously had
       * then clear the quantity
       */
      $scope.checkForSku = () => {
        $scope.checkToShowDosageAndPackageFields();
        const skus = $scope.model.product.skus;
        const filteredSkus = skus.filter((sku) => {
          const matchesDosage = $scope.model.dosage
            ? $scope.model.dosage === sku.dosage_label
            : true;
          const matchesPackage = $scope.model.package
            ? $scope.model.package === sku.package_label
            : true;
          return matchesDosage && matchesPackage;
        });

        const matchingSku = filteredSkus.length === 1 ? filteredSkus[0] : null;
        // check for quantity validation on sku if we have a match and if it is different than previous value
        if (matchingSku && matchingSku !== $scope.model.sku) {
          $scope.model.sku = matchingSku;
          const { min_quantity, max_quantity } = matchingSku;
          $scope.model.quantityIsInvalid = false;
          $scope.model.quantity = null;
          if (min_quantity === max_quantity) {
            $scope.model.quantity = max_quantity;
            $scope.model.quantityIsInvalid = false;
          }
        } else {
          $scope.model.sku = null;
        }
      };

      /**
       * Called when quantity input field is blurred
       * if we have a quantity then check it against max/min values on the selected sku
       */
      $scope.validateQuantity = () => {
        const { min_quantity, max_quantity } = $scope.model.sku || {};
        if ($scope.model.quantity) {
          const quantity = Number.parseInt($scope.model.quantity);
          if (quantity < min_quantity || quantity > max_quantity) {
            $scope.model.quantityIsInvalid = true;
          } else {
            $scope.model.quantityIsInvalid = false;
          }
        } else {
          $scope.model.quantityIsInvalid = true;
        }
      };

      $scope.onChangeProduct = () => {
        $scope.model.dosage = null;
        $scope.model.package = null;
        $scope.model.quantity = null;
        $scope.model.price = null;
        $scope.checkForSku();
      };

      $scope.onChangeDosage = () => {
        $scope.model.package = null;
        $scope.checkForSku();
      };

      $scope.onChangePackage = () => {
        $scope.checkForSku();
      };

      $scope.onAddAnotherProduct = () => {
        $scope.hideAddLineItemView = false;
      };

      $scope.onAddItem = () => {
        $scope.invoiceAddLineItem({
          item: { ...$scope.model },
          $http,
          ENV,
        });
        $scope.model = {};
        $scope.hideAddLineItemView = true;
      };

      $scope.onEditItem = () => {
        $scope.invoiceUpdateLineItem({ item: { ...$scope.model }, $http, ENV });
        $scope.model = {};
        $scope.hideAddLineItemView = true;
        $scope.isEditing = false;
      };

      $scope.onClickEdit = (item) => {
        if (item) {
          $scope.model = { ...item };
          $scope.isEditing = true;
          $scope.hideAddLineItemView = false;
        }
      };

      $scope.onClickDelete = (item) => {
        $scope.confirmDeleteDialogOptions = {
          heading: 'Please confirm',
          message: `Are you sure you want to delete ${item.product.brand} for ${item.pet.name}?`,
          buttons: [
            {
              label: 'OK',
              href: '#',
              clickFn: () => {
                // if we delete our only item then show add line item view
                if ($scope.invoice.items.length === 1) {
                  $scope.hideAddLineItemView = false;
                }
                $scope.showConfirmDelete = false;
                $scope.invoiceDeleteLineItem({ item, $http, ENV });
              },
            },
            {
              label: 'Cancel',
              href: '#',
              clickFn: () => {
                $scope.showConfirmDelete = false;
              },
            },
          ],
        };
        $scope.showConfirmDelete = true;
      };

      $scope.togglePromoCodeSelection = (code) => {
        $scope.invoiceTogglePromoCode({ code, $http, ENV });
      };

      $scope.onSubmit = () => {
        $scope
          .invoiceSubmitTransaction({ $http, ENV })
          .then(() => {
            if (!$scope.isOrganizationUser) {
              $scope.getData();
              $rootScope.closeComponent();
            } else {
              // if you are an organization we need to unset the active user on the user store
              // after stubmitting an invoice
              // eslint-disable-next-line no-param-reassign
              $rootScope.userId = null;
            }
            $scope.hideAddLineItemView = false;
          })
          .catch(() => {});
      };

      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        $scope.activeComponentListener();
      });
    },
    template,
  };
});
